<div class="container">
  <div class="tabs flex">
    <div [id]="'tab'+i"
      (click)="onChange(tab,i,bar)"
      [ngClass]="{'active':tab.active}"
      class=" tab flex jc-c ai-c"
      *ngFor="let tab of tabs;let i = index">
      {{tab.label | translate}}
    </div>
    <span #bar
      [ngStyle]="{'width': tabWidth}"
      class="active-bar"></span>
  </div>
</div>